import { usePermissions } from "react-admin";
import { PermissionRoles, PERMISSIONS } from "../roles";
import { useContext, useEffect, useRef, useState } from "react";
import { APIContext } from "../store/APIStore";
import { notificationType } from "../components/NotificationMessage/NotificationMessage";
import config from "../Configs/config";
import { StoreContext } from "../store/Store";

const getPermissionRoles = (permission: string) => {
  return PermissionRoles[permission];
};

export const useHasPermissions = (permission: string) => {
  const { permissions } = usePermissions(); // contains the logged in user roles

  if (!permissions) {
    return null;
  }

  const permissionRoles = getPermissionRoles(permission);
  const crossRoles = permissions.filter((value: keyof typeof PERMISSIONS) =>
    permissionRoles.includes(value)
  ); // get the intersection array of the logged-in user roles and the defined permission roles

  return crossRoles.length > 0;
};

export const useHasAnalyticsPermissions = () => {
  const { permissions } = usePermissions();

  const [canViewAnalytics, setCanViewAnalytics] = useState(false);

  const permissionRoles = getPermissionRoles(PERMISSIONS.CAN_VIEW_ANALYTICS);

  useEffect(() => {
    const crossRoles = (permissions || []).filter(
      (value: keyof typeof PERMISSIONS) => permissionRoles.includes(value)
    ); // get the intersection array of the logged-in user roles and the defined permission roles
    setCanViewAnalytics(crossRoles.length > 0);
  }, [config, permissions]);

  return {
    canViewAnalytics,
  };
};

export const useHasRole = (role: string) => {
  const { permissions } = usePermissions(); // contains the logged in user roles
  return permissions && permissions.indexOf(role) !== -1;
};

export const useHasLead = (eventId: string) => {
  const api = useContext(APIContext);
  const [state, dispatch] = useContext(StoreContext);
  const notificationRef = useRef<any>();
  const canManageLeads = useHasPermissions(PERMISSIONS.CAN_MANAGE_LEADS);

  const [loading, setLoading] = useState<boolean>(true);
  const [leadsInfo, setLeadsInfo] = useState<boolean>(false);

  const fetchLeadEventData = async () => {
    try {
      if (eventId && canManageLeads) {
        const { data } = await api.leadsService.getLeadEvent(eventId);
        setLeadsInfo(Boolean(data));
        dispatch({
          type: "SET_LEADS_DATA",
          payload: { leadsInfo: Boolean(data), loading: false },
        });
      }
      setLoading(false);
    } catch (error: any) {
      console.log(error.response);
      notificationRef.current?.show(
        error?.response?.data?.message,
        notificationType.Error
      );
    }
  };

  useEffect(() => {
    fetchLeadEventData();
  }, [config, eventId]);

  return {
    leadsInfo,
    loading,
    fetchLeadEventData,
  };
};
